var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"show-archived-tenders-btn spacex-4"},[_c('Icon',{attrs:{"type":"archive","size":"16"}}),_c('div',{staticClass:"text-sm text-primary"},[_vm._v(_vm._s(_vm.$t('Show archived tenders')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }